// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { LogOut } from "lucide-react";
// import apiConfig from "../config/apiConfig";
// import SidebarStudent from "./Utils/SidebarStudent";
// import { logout } from "../apis/backend";
// import { toast } from "../utils/toast";
// import "./Dashboard.css";

// declare global {
//   interface Window {
//     Razorpay: any;
//   }
// }

// const PaymentInitiate: React.FC = () => {
//   const navigate = useNavigate();
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showConfirmModal, setShowConfirmModal] = useState(false);

//   const handleLogout = async () => {
//     const ok = await logout();
//     if (ok) navigate("/");
//   };

//   const [loading, setLoading] = useState(false);
//   const [isAgreed, setIsAgreed] = useState(false);

//   const handlePayment = () => {
//     setShowConfirmModal(true);
//   };

//   const proceedWithPayment = async () => {
//     setShowConfirmModal(false);

//     try {
//       setLoading(true);

//       const internalOrderId = "ORD_" + Date.now();

//       // 1️⃣ Call backend to create Razorpay order
//       const res = await fetch(
//         "http://localhost:8082/api/payments/initiate/razorpay",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             internalOrderId,
//             amount: 1500,
//             currency: "INR",
//           }),
//           credentials: "include",
//         },
//       );

//       if (!res.ok) {
//         throw new Error("Order creation failed");
//       }

//       const data = await res.json();

//       // 2️⃣ Configure Razorpay
//       const options = {
//         key: data.key,
//         amount: data.amount,
//         currency: data.currency || "INR",
//         order_id: data.gatewayOrderId,

//         name: "IIIT Bangalore",
//         description: "Application Fee",

//         handler: function () {
//           // ⚠️ Do NOT trust this for success
//           window.location.href = `/payment-status?orderId=${internalOrderId}`;
//         },

//         modal: {
//           ondismiss: function () {
//             window.location.href = `/payment-status?orderId=${internalOrderId}`;
//           },
//         },
//       };

//       if (!window.Razorpay) {
//         throw new Error("Razorpay SDK not loaded. Please check your internet connection and refresh.");
//       }

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       console.error(err);
//       toast.error("Payment initiation failed. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="dash-layout">
//       <SidebarStudent
//         sidebarCollapsed={sidebarCollapsed}
//         toggleSidebar={() => setSidebarCollapsed((p) => !p)}
//       />

//       <div
//         className={`dash-wrapper ${sidebarCollapsed ? "dash-wrapper-collapsed" : ""}`}
//       >
//         <header className="dash-header">
//           <h1 className="dash-page-title">Declaration & Payment</h1>

//           <div className="dash-user-profile">
//             <div
//               className="dash-profile-circle"
//               onClick={() => setShowDropdown((p) => !p)}
//             >
//               <span>S</span>
//             </div>

//             {showDropdown && (
//               <div className="dash-profile-dropdown">
//                 <button onClick={handleLogout} type="button">
//                   <LogOut size={16} />
//                   <span>Logout</span>
//                 </button>
//               </div>
//             )}
//           </div>
//         </header>

//         <div className="dash-content-body">
//           <div className="m-4">
//             {/* Header Section */}

//             <div
//               className="border rounded p-4 bg-white"
//               style={{ borderColor: "#2D88D4", textAlign: "left" }}
//             >
//               <div className="mb-3">
//                 <a href="#" className="text-decoration-underline text-secondary fw-bold">
//                   Instruction/Guidelines
//                 </a>
//               </div>

//               <div className="mb-4 text-muted">
//                 I declare that the information provided is true to the best of my knowledge and I understand that providing any
//                 false information may lead to the rejection of the application and make me liable for legal proceedings.
//                 <br /><br />

//                 <strong>Note: Application Fee of Rs 1500 needs to be paid for your
//                 Application </strong>
//               </div>

//               <div className="form-check mb-4">
//                 <input
//                   className="form-check-input"
//                   type="checkbox"
//                   id="agreeCheck"
//                   checked={isAgreed}
//                   onChange={(e) => setIsAgreed(e.target.checked)}
//                   style={{ cursor: "pointer" }}
//                 />
//                 <label className="form-check-label text-muted" htmlFor="agreeCheck" style={{ cursor: "pointer" }}>
//                   I Agree
//                 </label>
//               </div>

//               {/* Moved Pay and Submit button inside the Instructions card */}
//               <div className="text-center mt-4 pt-3 border-top">
//                 <button
//                   onClick={handlePayment}
//                   disabled={loading || !isAgreed}
//                   className="btn text-white px-4 py-2"
//                   style={{
//                     background: isAgreed && !loading ? "#28a745" : "#a1d6b0", // Greenish for final submit
//                     fontSize: "16px",
//                     borderRadius: "5px",
//                     cursor: isAgreed && !loading ? "pointer" : "not-allowed",
//                     border: "none",
//                   }}
//                 >
//                   {loading ? "Processing..." : "Pay and Submit"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Confirmation Modal */}
//         {showConfirmModal && (
//           <div
//             style={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "100%",
//               backgroundColor: "rgba(0, 0, 0, 0.5)",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               zIndex: 1050,
//             }}
//           >
//             <div
//               className="bg-white p-5 rounded shadow-lg"
//               style={{ width: "600px", maxWidth: "95%", textAlign: "center" }}
//             >
//               <h4 className="mb-4 text-dark fw-bold">Confirm Submission</h4>
//               <p className="mb-4 text-muted" style={{ fontSize: "16px", lineHeight: "1.6" }}>
//                 After clicking 'OK' to proceed with Pay and Submit, you will NOT be able to edit this application further. Do you want to continue?
//               </p>
//               <div className="d-flex justify-content-center mt-4" style={{ gap: "15px" }}>
//                 <button
//                   className="btn btn-secondary px-4 py-2"
//                   style={{ fontSize: "16px", minWidth: "120px" }}
//                   onClick={() => setShowConfirmModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="btn btn-primary px-4 py-2"
//                   style={{ fontSize: "16px", minWidth: "120px" }}
//                   onClick={proceedWithPayment}
//                   disabled={loading}
//                 >
//                   {loading ? "Processing..." : "OK"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// };

// export default PaymentInitiate;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, LogOut } from "lucide-react";
import apiConfig from "../config/apiConfig";
import SidebarStudent from "./Utils/SidebarStudent";
import { logout } from "../apis/backend";
import { toast } from "../utils/toast";
import "./Dashboard.css";
import LogoutButton from "./LogoutButton";
import { X, ChevronDown, ChevronUp } from "lucide-react";
import RenderImage from "./QueryManager/RenderImage/RenderImage";
import { apiFetch } from "../apis/apiFetch";
import { useAdmissionDriveKind } from "../hooks/useAdmissionDriveKind";
import { useExamdetailsViewModel } from "../viewModels/useExamDetailsViewMore";

const SECTION_LABELS: Record<string, string> = {
  personal_details: "Personal Details",
  guardian_details: "Parent & Guardians Details",
  education_details: "Education Details",
  exam_details: "Exam Details",
  programme_details: "Programme Details",
};

const FIELD_LABELS: Record<string, string> = {
  fullname: "Full Name",
  email: "Email",
  mobile: "Mobile",
  dob: "Date of Birth",
  gender: "Gender",
  photo: "Photo",
  nationality: "Nationality",
  abc_id: "ABC ID",
  line1: "Line 1",
  line2: "Line 2",
  city: "City",
  state: "State",
  pincode: "Pincode",
  country: "Country",
  p_line1: "Line 1",
  p_line2: "Line 2",
  p_city: "City",
  p_state: "State",
  p_pincode: "Pincode",
  p_country: "Country",
  name: "Name",
  relation: "Relation",
  guardian_mobile: "Mobile Number",
  guardian_email: "Email",
  alternatemobile: "Alternate Mobile",
  edu10_board: "Education Board",
  edu10_schoolname: "School/College",
  edu10_passingyear: "Year of Passing",
  edu10_marksformat: "Grade/Marks Type",
  edu10_marksobtained: "Marks Obtained",
  edu10_maximummarks: "Maximum Marks",
  edu10_percentage: "Percentage",
  edu10_grade: "Grade",
  edu12_board: "Education Board",
  edu12_schoolname: "School/College",
  edu12_passingyear: "Year of Passing",
  edu12_specialization: "Specialization",
  edu12_marksformat: "Grade/Marks Type",
  edu12_marksobtained: "Marks Obtained",
  edu12_maximummarks: "Maximum Marks",
  edu12_percentage: "Percentage",
  edu12_grade: "Grade",
  pref1: "Preference 1",
  pref2: "Preference 2",
  pref3: "Preference 3",
  pref4: "Preference 4",
  pref5: "Preference 5",
  jeemain_rollno: "JEE Main Application No.",
  jeemain_score: "JEE Main NTA Score",
  jeemain_rank: "JEE Main Rank (CRL)",
  jeemain_scorecard: "JEE Main Scorecard",
  jeeadv_rollno: "JEE Advanced Enrolment Number",
  jeeadv_score: "JEE Advanced Score",
  jeeadv_rank: "JEE Advanced Rank (CRL)",
  jeeadv_scorecard: "JEE Advanced Scorecard",
  olympiad_name: "Olympiad Training Camp Name",
  olympiad_no: "Hall Ticket Number",
  olympiad_year: "Year of Olympiad",
  olympiad_proof: "Proof of Olympiad Training",
  // Headers (internal)
  _addr_current: "Current Address",
  _addr_permanent: "Permanent Address",
  _edu10_header: "Class Xth / SSC",
  _edu12_header: "Class XIIth / HSC",
  _jeemain_header: "JEE Main 2026",
  _jeeadv_header: "JEE Advanced (Optional)",
  _olympiad_header: "Olympiad Details (Optional)",
};

const SECTION_FIELD_ORDER: Record<string, string[]> = {
  personal_details: ["fullname", "email", "mobile", "dob", "gender", "nationality", "abc_id", "photo", "_addr_current", "line1", "line2", "city", "state", "pincode", "country", "_addr_permanent", "p_line1", "p_line2", "p_city", "p_state", "p_pincode", "p_country"],
  guardian_details: ["name", "relation", "guardian_mobile", "guardian_email", "alternatemobile"],
  education_details: ["_edu10_header", "edu10_board", "edu10_schoolname", "edu10_passingyear", "edu10_marksformat", "edu10_marksobtained", "edu10_maximummarks", "edu10_percentage", "edu10_grade", "_edu12_header", "edu12_board", "edu12_schoolname", "edu12_passingyear", "edu12_specialization", "edu12_marksformat", "edu12_marksobtained", "edu12_maximummarks", "edu12_percentage", "edu12_grade"],
  exam_details: ["_jeemain_header", "jeemain_rollno", "jeemain_score", "jeemain_rank", "jeemain_scorecard", "_jeeadv_header", "jeeadv_rollno", "jeeadv_score", "jeeadv_rank", "jeeadv_scorecard", "_olympiad_header", "olympiad_name", "olympiad_no", "olympiad_year", "olympiad_proof"],
  programme_details: ["pref1", "pref2", "pref3", "pref4", "pref5"],
};

declare global {
  interface Window {
    Razorpay: any;
  }
}

const PaymentInitiate: React.FC = () => {
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [appLoading, setAppLoading] = useState(false)
  const [isAgreed, setIsAgreed] = useState(false);

  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState<any>(null);
  const [expandedSections, setExpandedSections] = useState<Set<string>>(new Set(Object.keys(SECTION_LABELS)));

  const { kind } = useAdmissionDriveKind();

  const mapFlatToSections = (record: any): Record<string, any> => {
    const sectioned: Record<string, any> = {
      personal_details: {
        fullname: record.fullname, email: record.email, mobile: record.mobile,
        dob: record.dob, gender: record.gender, nationality: record.nationality,
        photo: record.photo, abc_id: record.abc_id,
        line1: record.line1, line2: record.line2, city: record.city,
        state: record.state, pincode: record.pincode, country: record.country,
        p_line1: record.p_line1, p_line2: record.p_line2, p_city: record.p_city,
        p_state: record.p_state, p_pincode: record.p_pincode, p_country: record.p_country,
      },
      guardian_details: {
        name: record.guardian_name, relation: record.guardian_relation,
        guardian_mobile: record.guardian_mobile, guardian_email: record.guardian_email,
        alternatemobile: record.alternatemobile,
      },
      education_details: {
        edu10_board: record.edu10_board, edu10_schoolname: record.edu10_schoolname,
        edu10_passingyear: record.edu10_passingyear, edu10_marksformat: record.edu10_marksformat,
        edu10_marksobtained: record.edu10_marksobtained, edu10_maximummarks: record.edu10_maximummarks,
        edu10_percentage: record.edu10_percentage, edu10_grade: record.edu10_grade,
        edu12_board: record.edu12_board, edu12_schoolname: record.edu12_schoolname,
        edu12_passingyear: record.edu12_passingyear, edu12_specialization: record.edu12_specialization,
        edu12_marksformat: record.edu12_marksformat,
        edu12_marksobtained: record.edu12_marksobtained, edu12_maximummarks: record.edu12_maximummarks,
        edu12_percentage: record.edu12_percentage, edu12_grade: record.edu12_grade,
      },
      exam_details: {
        jeemain_rollno: record.jeemain_rollno, jeemain_score: record.jeemain_score,
        jeemain_rank: record.jeemain_rank, jeemain_scorecard: record.jeemain_scorecard,
        jeeadv_rollno: record.jeeadv_rollno, jeeadv_score: record.jeeadv_score,
        jeeadv_rank: record.jeeadv_rank, jeeadv_scorecard: record.jeeadv_scorecard,
        olympiad_name: record.olympiad_name, olympiad_no: record.olympiad_no,
        olympiad_year: record.olympiad_year, olympiad_proof: record.olympiad_proof,
      },
      programme_details: {
        pref1: record.pref1, pref2: record.pref2, pref3: record.pref3,
        pref4: record.pref4, pref5: record.pref5,
      },
    };

    Object.keys(sectioned).forEach((key) => {
      const section = sectioned[key];
      const hasData = Object.values(section).some(v => v !== null && v !== undefined && v !== "");
      if (!hasData) delete sectioned[key];
    });
    return sectioned;
  };

  const handlePreview = async () => {
    try {
      const stored = localStorage.getItem("user");
      const user = JSON.parse(stored || "{}");

      if (!user?.userId) {
        console.error("No userId found in stored user object");
        toast.error("User session not found. Please login again.");
        return;
      }

      setLoading(true);
      const res = await apiFetch(
        `${apiConfig.getResourceUrl('applications')}?queryId=GET_APPLICATIONS_BY_USER_ID&args=user_id:${user.userId}`,
        { method: "GET" }
      );
      if (res.ok) {
        const data = await res.json();
        const activeDriveId = localStorage.getItem("activeDriveId");
        const app = (data.resource || []).find((a: any) => a.drive_id === activeDriveId);

        if (app) {
          setPreviewData(mapFlatToSections(app));
          setShowPreview(true);
        } else {
          toast.error("Application data not found for current drive.");
        }
      } else {
        console.error("API response not OK", res.status);
        toast.error("Failed to fetch application data.");
      }
    } catch (err) {
      console.error("Error in handlePreview:", err);
      toast.error("Failed to load application preview.");
    } finally {
      setLoading(false);
    }
  };

  const formatFieldLabel = (key: string) => {
    if (FIELD_LABELS[key]) return FIELD_LABELS[key];
    return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const formatFieldValue = (key: string, val: any): React.ReactNode => {
    if (val === null || val === undefined || val === "") return "—";
    if (key === "dob") {
      try {
        const d = new Date(val);
        if (!isNaN(d.getTime())) {
          return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
        }
      } catch { }
    }
    if (key.includes("scorecard") || key === "photo" || key.includes("proof")) {
      return <RenderImage photo={val} key={key} />;
    }
    return String(val);
  };

  const toggleSection = (key: string) => {
    setExpandedSections(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const userId = "student"; // replace if from context
  const appId = "admission-portal";

  const {
    save,
  } = useExamdetailsViewModel(userId, appId);

  const handlePayment = () => {
    setShowConfirmModal(true);
  };
  const [app, setApp] = useState<any>(null)

  const handleSave = async () => {

    try {
      const finalPayload = { ...app, status: "EDIT_SUBMIT" };


      await save(finalPayload);

      toast.success("Application Saved");
      navigate("/applicant/home")

    } catch (error) {
      console.error("Error saving exam details:", error);
      toast.error("Error saving details. Please try again.");
    }

  };

  useEffect(() => {
    getApp()
  }, [])

  const getApp = async () => {
    setAppLoading(true);

    const stored = localStorage.getItem("user");
    const user = JSON.parse(stored || "{}");
    const fetchRes = await apiFetch(
      `${apiConfig.getResourceUrl('applications')}?queryId=GET_APPLICATIONS_BY_USER_ID&args=user_id:${user.userId}`,
      { method: "GET" }
    );
    if (fetchRes.ok) {
      const data = await fetchRes.json();
      const activeDriveId = localStorage.getItem("activeDriveId");
      const app = (data.resource || []).find((a: any) => a.drive_id === activeDriveId);
      setApp(app)
      setAppLoading(false);
    } else {
      setAppLoading(false);
      toast.error("Failed to fetch application data.");
      return;
    }
  }
  const proceedWithPayment = async () => {
    setShowConfirmModal(false);

    try {
      setLoading(true);

      const stored = localStorage.getItem("user");
      const user = JSON.parse(stored || "{}");

      if (!user?.userId) {
        toast.error("User session not found. Please login again.");
        return;
      }

      let appId = "";
      if (app && app.id) {
        appId = app.id;
      } else {
        toast.error("Application data not found for current drive.");
        return;
      }


      const internalOrderId = "ORD_" + Date.now();

      // ✅ Call backend to create Razorpay order
      const res = await fetch(
        `${apiConfig.API_BASE_URL}/payments/initiate/razorpay?appId=${appId}&round=false`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            internalOrderId,
            amount: 1500,
            currency: "INR",
          }),
          credentials: "include",
        }
      );

      if (!res.ok) {
        throw new Error("Order creation failed");
      }

      const data = await res.json();

      // ✅ Razorpay configuration
      const options = {
        key: data.key,
        amount: data.amount,
        currency: data.currency || "INR",
        order_id: data.gatewayOrderId,

        name: "IIIT Bangalore",
        description: "Application Fee",

        handler: function () {
          window.location.href = `/payment-status?orderId=${internalOrderId}`;
        },

        modal: {
          ondismiss: function () {
            window.location.href = `/payment-status?orderId=${internalOrderId}`;
          },
        },
      };

      if (!window.Razorpay) {
        throw new Error("Razorpay SDK not loaded.");
      }

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {
      console.error(err);
      toast.error("Payment initiation failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dash-layout">
      <SidebarStudent
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebar={() => setSidebarCollapsed((p) => !p)}
      />

      <div
        className={`dash-wrapper ${sidebarCollapsed ? "dash-wrapper-collapsed" : ""}`}
      >
        <header className="dash-header">
          <h1 className="dash-page-title">Declaration & Payment</h1>

          <div className="dash-user-profile">
            <div
              className="dash-profile-circle"
              onClick={() => setShowDropdown((p) => !p)}
            >
              <span>S</span>
            </div>

            {showDropdown && (
              <div className="dash-profile-dropdown">
                <LogoutButton />
              </div>
            )}
          </div>
        </header>

        {!appLoading && <div className="dash-content-body">
          <div className="m-4">

            <div
              className="border rounded p-4 bg-white"
              style={{ borderColor: "#2D88D4", textAlign: "left" }}
            >

              {app?.status === "EDITING" && app.payment_status === "SUCCESS" ?
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f4f7f6",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="bg-white p-5 rounded shadow-lg text-center"
                      style={{ width: "450px", maxWidth: "100%" }}
                    >
                      {/* Status Area */}
                      <div className="mb-4">
                        <CheckCircle size={64} className="text-success mb-3 mx-auto" />
                        <h3 className="text-success fw-bold">Payment Successful!</h3>
                        <p className="text-muted mt-2">Your application fee has been received successfully.</p>
                      </div>
                    </div>
                  </div>
                </>
                :
                <>
                  <div className="mb-3">
                    <a href="#" className="text-decoration-underline text-secondary fw-bold">
                      Instruction/Guidelines
                    </a>
                  </div>

                  <div className="mb-4 text-muted">
                    I declare that the information provided is true to the best of my knowledge and I understand that providing any
                    false information may lead to the rejection of the application and make me liable for legal proceedings.
                    <br /><br />
                    <strong>Note: Application Fee of Rs 1500 needs to be paid.</strong>
                  </div>

                  <div className="form-check mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="agreeCheck"
                      checked={isAgreed}
                      onChange={(e) => setIsAgreed(e.target.checked)}
                      style={{ cursor: "pointer" }}
                    />
                    <label className="form-check-label text-muted" htmlFor="agreeCheck">
                      I Agree
                    </label>
                  </div>
                </>
              }

              <div className="text-center mt-4 pt-3 border-top">
                {app?.status === "EDITING" && app.payment_status === "SUCCESS" ?
                  <button
                    onClick={handleSave}
                    className="btn text-white px-4 py-2"
                    style={{
                      background: "#28a745",
                      fontSize: "16px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      border: "none",
                    }}
                  >
                    {loading ? "Processing..." : "Submit"}
                  </button> :
                  <button
                    onClick={handlePayment}
                    disabled={loading}
                    className="btn text-white px-4 py-2"
                    style={{
                      background: isAgreed && !loading ? "#28a745" : "#a1d6b0",
                      fontSize: "16px",
                      borderRadius: "5px",
                      cursor: isAgreed && !loading ? "pointer" : "not-allowed",
                      border: "none",
                    }}
                  >
                    {loading ? "Processing..." : "Pay and Submit"}
                  </button>
                }
              </div>

            </div>
          </div>
        </div>}

        {showConfirmModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1050,
            }}
          >
            <div className="bg-white p-5 rounded shadow-lg" style={{ width: "600px", maxWidth: "95%", textAlign: "center" }}>
              <h4 className="mb-4 text-dark fw-bold">Confirm Submission</h4>
              <p className="mb-4 text-muted">
                After clicking <strong>"Proceed to Pay"</strong>, you will <strong>NOT</strong> be able to edit this application further. Kindly preview your application before proceeding.
              </p>

              <div className="d-flex justify-content-center mt-4" style={{ gap: "15px" }}>
                <button
                  className="btn btn-secondary px-3 py-2"
                  onClick={() => setShowConfirmModal(false)}
                >
                  Cancel & Edit
                </button>

                {kind === "btech" && (
                  <button
                    className="btn btn-info px-4 py-2 text-white"
                    onClick={handlePreview}
                    disabled={loading}
                  >
                    Preview Application
                  </button>
                )}

                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={proceedWithPayment}
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Proceed to Pay"}
                </button>
              </div>

            </div>
          </div>
        )}

        {showPreview && previewData && (
          <div
            style={{
              position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
              backgroundColor: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center",
              alignItems: "center", zIndex: 2000, padding: "20px"
            }}
          >
            <div
              className="bg-white rounded shadow-xl"
              style={{ width: "900px", maxWidth: "100%", height: "90vh", display: "flex", flexDirection: "column" }}
            >
              <div className="p-4 border-bottom d-flex justify-content-between align-items-center">
                <h4 className="m-0 fw-bold">Application Preview</h4>
                <button
                  className="btn btn-link p-0 text-dark"
                  onClick={() => setShowPreview(false)}
                >
                  <X size={24} />
                </button>
              </div>

              <div className="p-4" style={{ overflowY: "auto", flex: 1 }}>
                {Object.keys(previewData).map((secKey) => {
                  const sectionData = previewData[secKey];
                  const isExpanded = expandedSections.has(secKey);
                  return (
                    <div key={secKey} className="mb-4 border rounded overflow-hidden">
                      <div
                        className="p-3 bg-light d-flex justify-content-between align-items-center cursor-pointer"
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleSection(secKey)}
                      >
                        <h6 className="m-0 fw-bold">{SECTION_LABELS[secKey] || secKey}</h6>
                        {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                      </div>

                      {isExpanded && (
                        <div className="p-3 bg-white">
                          <div className="row">
                            {(SECTION_FIELD_ORDER[secKey] || Object.keys(sectionData)).map((fieldKey) => {
                              // ✅ Handle internal subheaders (prefixed with _)
                              if (fieldKey.startsWith("_")) {
                                const optionalHeaders = ["_jeeadv_header", "_olympiad_header"];
                                if (optionalHeaders.includes(fieldKey)) {
                                  const subFields = fieldKey === "_jeeadv_header"
                                    ? ["jeeadv_rollno", "jeeadv_score", "jeeadv_rank", "jeeadv_scorecard"]
                                    : ["olympiad_name", "olympiad_no", "olympiad_proof"];

                                  const hasAnyData = subFields.some(f =>
                                    sectionData[f] !== null &&
                                    sectionData[f] !== undefined &&
                                    String(sectionData[f]).trim() !== ""
                                  );

                                  if (!hasAnyData) {
                                    return (
                                      <React.Fragment key={fieldKey}>
                                        <div className="col-12 mt-4 mb-2 border-bottom pb-1">
                                          <h6 className="m-0 text-bold fw-bold" style={{ fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                            {FIELD_LABELS[fieldKey]}
                                          </h6>
                                        </div>
                                        <div className="col-12 mb-3">
                                          <span className="text-muted fw-normal">N/A</span>
                                        </div>
                                      </React.Fragment>
                                    );
                                  }
                                }

                                return (
                                  <div key={fieldKey} className="col-12 mt-4 mb-2 border-bottom pb-1">
                                    <h6 className="m-0 text-bold fw-bold" style={{ fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                      {FIELD_LABELS[fieldKey]}
                                    </h6>
                                  </div>
                                );
                              }

                              // Skip rendering individual fields if they belong to an empty optional subheader
                              if (fieldKey.startsWith("jeeadv_")) {
                                const hasAdvData = ["jeeadv_rollno", "jeeadv_score", "jeeadv_rank", "jeeadv_scorecard"].some(f =>
                                  sectionData[f] !== null && sectionData[f] !== undefined && String(sectionData[f]).trim() !== ""
                                );
                                if (!hasAdvData) return null;
                              }
                              if (fieldKey.startsWith("olympiad_")) {
                                const hasOlyData = ["olympiad_name", "olympiad_no", "olympiad_proof"].some(f =>
                                  sectionData[f] !== null && sectionData[f] !== undefined && String(sectionData[f]).trim() !== ""
                                );
                                if (!hasOlyData) return null;
                              }

                              if (sectionData[fieldKey] === undefined) return null;
                              return (
                                <div key={fieldKey} className="col-md-6 mb-3">
                                  <label className="text-secondary small d-block mb-1">
                                    {formatFieldLabel(fieldKey)}
                                  </label>
                                  <div className="fw-medium">
                                    {formatFieldValue(fieldKey, sectionData[fieldKey])}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              <div className="p-4 border-top text-center">
                <button
                  className="btn btn-secondary px-5"
                  onClick={() => setShowPreview(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentInitiate;
